import type { SVGProps } from 'react';
const resCrossTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.2174 12.158L19.6181 17.4003C20.2126 17.9774 20.2267 18.927 19.6497 19.5214C19.0727 20.1159 18.123 20.13 17.5286 19.553L12.0638 14.2485L6.68083 19.4735C6.08639 20.0505 5.13675 20.0364 4.55974 19.442C3.98274 18.8475 3.99687 17.8979 4.59131 17.3209L9.91017 12.158L4.42228 6.83109C3.82784 6.25408 3.81371 5.30444 4.39072 4.71C4.96772 4.11556 5.91736 4.10143 6.5118 4.67844L12.0638 10.0676L17.551 4.74129C18.1454 4.16429 19.0951 4.17842 19.6721 4.77286C20.2491 5.3673 20.235 6.31694 19.6405 6.89394L14.2174 12.158Z"
      fill={props.color ?? '#144761'}
    />
  </svg>
);
export default resCrossTemplateOutline;
